import React, { useState, useEffect } from "react"
import classnames from "classnames"
import { FormGroup, Label } from "reactstrap"
import { HIs, MyIcon, MyUI } from "@macashipo/mlib"
import { BiInfoCircle } from "react-icons/bi"
import Tooltip from "src/core/components/Others/Tooltip"
import styled from "styled-components"
interface IProps {
  control: any
  className?: any
  value?: any
  label?: string
  onUpdateValue?: any
  onUpdateValueWithFieldName?: any
  onUpdateMulti?: any
  fieldName?: string
  hint?: string
  isControlFirst?: boolean
  isCheckTypeControl?: boolean
  controlOpts?: IControlOpts
  innerRef?: any
}

const getIdForControl = props => {
  const { fieldName, controlOpts } = props
  return `mfc-${fieldName}${
    controlOpts?.prefixId ? "-" + controlOpts.prefixId : ""
  }`
}

const WrapHint = (props: any) => {
  return (
    <Tooltip overlay={props.hint} placement="top">
      <div style={{ display: "inline-block" }}>
        <MyIcon style={{ color: "#6088b3" }} data={"fa fa-question-circle-o"} />
      </div>
    </Tooltip>
  )
}
const MyFormControlWrap = (props: IProps) => {
  const {
    isControlFirst,
    isCheckTypeControl,
    fieldName,
    controlOpts,
    className,
  } = props
  const [value] = useState(props.value)
  const onUpdateValue = (newValue, opts: any = null) => {
    console.warn("MyFormControlWrap:", newValue, value, newValue !== value)
    // if (
    //   // newValue !== value &&
    //   !(value === null && newValue === "")) {
    //   props.onUpdateValue(newValue)
    // }
    props.onUpdateValue(newValue, opts)
  }
  const hint: any = props.controlOpts?.hint
  const { styleLabel, ui }: any = controlOpts || {}
  // console.warn("render:", props)
  // if (props && props.controlOpts && props.controlOpts.fnList.initWrapControl) {
  //   props.controlOpts.fnList.initWrapControl(props.fieldName, {
  //     forceUpdate: () => {
  //       console.warn("foreceUpdate from fn")
  //     },
  //   })
  // }
  let classNameGroup = ""
  if (isCheckTypeControl) {
    classNameGroup = classnames(
      "mb-3 check-control",
      props.controlOpts?.classNameGroup
    )
  } else {
    classNameGroup = classnames("mb-3", props.controlOpts?.classNameGroup)
  }
  if (className) {
    classNameGroup = classnames(classNameGroup, className)
  }
  useEffect(() => {
    const { fnCustomLink } = ui || {}
    if (fnCustomLink) {
      fnCustomLink()
    }
    // eslint-disable-next-line
  }, [ui])
  return (
    <FormGroup className={classNameGroup} data-field={fieldName}>
      {isControlFirst !== true &&
        controlOpts?.hideLabel !== true &&
        props.label && (
          <div style={{ display: "flex" }}>
            <Label
              for={getIdForControl(props)}
              className="label-control mb-1"
              title={typeof props.label === "string" ? props.label : ""}
              style={styleLabel}
            >
              {props.label} {HIs.isString(hint) && <WrapHint hint={hint} />}
            </Label>
            {ui?.showError && !ui?.textError && (
              <div style={{ color: "var(--color-danger)" }}>&nbsp;*</div>
            )}
          </div>
        )}
      <div className="sub-label-control w-100">{controlOpts?.subLabel}</div>
      <div
        className={
          ui?.showRequiredEnd
            ? classnames(
                "wrap-required-end",
                props.controlOpts?.classNameControl
              )
            : props.controlOpts?.classNameControl
        }
      >
        {props.control != null &&
          props.control({
            defaultValue: value,
            defaultChecked: value,
            controlOpts: {
              onUpdateValue: onUpdateValue,
              onUpdateValueWithFieldName: props.onUpdateValueWithFieldName,
              onUpdateMulti: props.onUpdateMulti,
              fieldName: fieldName,
              ...props.controlOpts,
            },
            id: getIdForControl(props),
            onBlur: ev => {
              // console.warn(ev.currentTarget.checked)
              if (isCheckTypeControl) {
                onUpdateValue(ev.currentTarget.checked)
              } else {
                onUpdateValue(ev.currentTarget.value)
              }
            },
            innerRef: props.innerRef,
          })}
        {ui?.showRequiredEnd && ui?.showError && !ui?.textError && (
          <div
            // className={ui?.textError ? "required-end has-msg" : "required-end"}
            className={"required-end"}
          >
            *
          </div>
        )}
      </div>
      {isControlFirst === true && (
        <Label for={getIdForControl(props)} className="ms-2">
          {props.label}
          {ui?.showError && !ui?.textError && (
            <span style={{ color: "var(--color-danger)" }}>&nbsp;*</span>
          )}
        </Label>
      )}
      {props.hint && <div className="form-text">{props.hint}</div>}
      {ui?.showMsgInWrap &&
        ((ui?.showError && ui?.textError) || (ui?.showInfo && ui.textInfo)) && ( // hien tai chi dang apply cho type checkbox
          <div className="w-100">
            {ui?.showError && ui?.textError && (
              <Error className="__msgerr" style={ui.styleError}>
                <BiInfoCircle />
                <MyUI type="html" html={ui.textError} style={{ flex: 1 }} />
              </Error>
            )}
            {ui?.showInfo && (
              <Info className="__msginf">
                <BiInfoCircle />
                <span>{ui.textInfo}</span>
              </Info>
            )}
          </div>
        )}
    </FormGroup>
  )
}
const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-text-info);
  font-size: 13px;
  margin: 0.5rem 0;
  & > svg {
    margin-right: 0.25rem;
    width: 15px;
    height: 15px;
  }
`
const Error = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-danger);
  font-size: 13px;
  margin: 0.5rem 0;
  & > svg {
    margin-right: 0.25rem;
    width: 15px;
    height: 15px;
  }
`
export default MyFormControlWrap
